import AdminPanelIcon from '@material-design-icons/svg/filled/admin_panel_settings.svg?react';
import { Outlet, useLocation } from 'react-router';
import { AdminNav } from './AdminNav';
import { DashboardHeader } from './dashboard/DashboardHeader';

const ADMIN_SECTIONS: Array<{
  match: (pathname: string) => boolean;
  title: string;
}> = [
  {
    match: (path) => path === '/admin' || path === '/admin/',
    title: 'Overview',
  },
  {
    match: (path) => path.startsWith('/admin/users'),
    title: 'User Management',
  },
  {
    match: (path) => path.startsWith('/admin/kyb'),
    title: 'KYC/KYB Management',
  },
  {
    match: (path) => path.startsWith('/admin/invites'),
    title: 'Invite Code Management',
  },
];

function getAdminSectionTitle(pathname: string) {
  const normalizedPath = pathname.replace(/\/$/, '') || '/admin';
  const match = ADMIN_SECTIONS.find((section) => section.match(normalizedPath));
  return match?.title ?? '';
}

export function AdminLayout() {
  const location = useLocation();
  const sectionTitle = getAdminSectionTitle(location.pathname);
  const baseTitle = 'Admin Dashboard';
  const title = sectionTitle ? `${baseTitle} - ${sectionTitle}` : baseTitle;

  return (
    <div className="min-h-screen flex flex-col">
      <DashboardHeader
        icon={<AdminPanelIcon className="fill-current text-white size-6" />}
        title={title}
      />

      <AdminNav />

      <Outlet />
    </div>
  );
}
